import { useScript } from '#nuxt-scripts/composables/useScript'
import { defineNuxtPlugin } from 'nuxt/app'
import { useScriptGoogleTagManager } from '/app/node_modules/.pnpm/@nuxt+scripts@1.3.8_@oxc-project+types@0.151.0_@unhead+vue@3.4.0_@oxc-project+types@0.1_7e225cd0954551201c6bdc614ef17cb0/node_modules/@nuxt/scripts/dist/runtime/registry/google-tag-manager.js'

export default defineNuxtPlugin({
  name: "scripts:init",
  env: { islands: false },
  parallel: true,
  setup() {
    const googleTagManager = useScriptGoogleTagManager({"id":"GTM-5Z9GQ7VQ","scriptOptions":{"bundle":false,"trigger":"onNuxtReady"}})
    return { provide: { scripts: { googleTagManager } } }
  }
})